import React from 'react';
import styled from 'react-emotion';

import BaseButton from '@material-ui/core/Button';
import BaseVisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const CollapsableContainer = styled('div')`
  box-shadow: none;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: ${colors.grey8};
  max-width: 1000px;
  width: 100%;
`;

export const TitleBar = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
  padding-left: 11px;
  padding-right: 11px;
`;

export const TitleText = styled('div')`
  color: ${colors.purple};
  font-size: 14px;
  font-weight: 500;
`;

export const ActionsArea = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ContentContainer = styled('div')`
  border-top: 1px solid ${colors.grey8};
  min-height: 44px;
`;

export const FooterContainer = styled('div')`
  height: 44px;
  border-top: 1px solid ${colors.grey8};
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 12px;
`;

export const FooterButton = styled(({ children, ...props }) => (
  <BaseButton color="primary" variant="text" {...props}>
    {children}
  </BaseButton>
))`
  text-transform: none;
  font-size: 12px;
  font-weight: 500;
  padding-left: 0;
  &:hover {
    background-color: white;
    opacity: 0.5;
  }
  flex: 1;
  justify-content: start;
  color: ${colors.primary};
`;

export const FooterButtonText = styled('div')`
  padding-left: 8px;
`;

export const VisibilityOffIcon = styled(BaseVisibilityOffIcon)`
  color: ${theme.color.grayDark};
`;
